import React from 'react'
import { Link } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import { faEdit, faEye, faIdCard } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import VerRequerimiento from './modales/VerRequerimiento'
import EditarRequerimiento from './modales/EditarRequerimiento'
import { ESTADOS } from '../../constants/hardCodedConstants'
import VerDetalle from '../registroMaternidad/modales/verDetalle/VerDetalle'
import {
    agregarStringAArraydDeStringsSiNoExiste,
    stringSeEncuentraEnArray
} from "../../helper/utils";

const TableWebBody = ({ filas, setModalEnabled, handleToggleEsControl,

                          setIdsRequerimientosConCheck}) => {

    const checkboxClic = (e, solicitud) => {
        let isChecked = e.target.checked;
        let id = solicitud["IdRequerimientoPersonal"];

        if (isChecked) {
            // Usamos el set con un callback para asegurar que tenemos el estado más reciente
            setIdsRequerimientosConCheck(prev =>
                agregarStringAArraydDeStringsSiNoExiste(id, prev)
            );
        } else {
            setIdsRequerimientosConCheck(prev =>
                eliminarStringDeArraydDeStrings(id, prev)
            );
        }
    };

    const eliminarStringDeArraydDeStrings = (string, array) => {
        return array.filter(item => item !== string);
    };


    return (
    <tbody className="listar-tbody">
      {filas.map((fila,i)=> (
        <tr key={`${i}-${fila.IdRequerimientoPersonal}`}>
            <td className="text-center">
                <div className="flex items-center justify-center gap-2">
                    {fila?.PuedeUnirseConOtroRequerimiento &&
                        <input
                            type="checkbox"
                            onClick={(e) => checkboxClic(e, fila)}
                        />
                    }
                    <span>{fila?.IdRequerimientoPersonal}</span>
                </div>
            </td>
          <td className="text-center">{fila?.FechaRegistro}</td>
          <td className="text-center">{fila?.FechaAprobacion}</td>
          <td className="text-center">{fila?.FechaCompletado}</td>
          <td className="text-center">{fila?.CantidadDiasTiempoAtencion}</td>
          <td className="">{fila?.Sede}</td>
          <td className="">{fila?.Division}</td>
          <td className="">{fila?.Gerencia}</td>
          <td className="">{fila?.Area}</td>
          <td className="text-center">{fila?.Cargo}</td>
          <td className="text-center">{fila?.EspecialidadSeleccion}</td>
          <td className="text-center">{fila?.TipoEmpleado }</td>
          <td className="text-center">{fila?.AvanceRequerimiento}</td>
          <td className="text-center">{fila?.EstadoAprobacion}</td>
          <td className="text-center">{fila?.EstadoProceso}</td>
          <td className="">{fila?.Colaborador}</td>
          <td className="text-center">
            {/* 30/09/2026, a pedido de Jody: oculto si el requerimiento ya está
                reservado por un postulante de Traslados y Promociones
                (RequerimientoPersonal.IdPostulanteTP no nulo). */}
            {!fila?.RequerimientoReservadoEnTrasladoYPromocion &&
              <input className='hand-pointer' type='checkbox' checked={fila.EsControl === ESTADOS.SI} value={fila.EsControl} onChange={() => handleToggleEsControl(fila.IdRequerimientoPersonal)}/>
            }
          </td>
          <td className="text-center">
            <div className="d-flex justify-content-center blue_innova_text" style={{ gap: "10px" }}>
              {fila?.TieneCeseRechazado &&
                <GenericTooltip id={`ceseRechazado-${fila.IdRequerimientoPersonal}`}/>
              }
              <FontAwesomeIcon
                icon={faEye}
                size="lg"
                className='hand-pointer blue_innova_text'
                title="Ver Detalles"
                onClick={() => {
                  setModalEnabled({isEnable: true, component: VerRequerimiento, data: {id: fila.IdRequerimientoPersonal, idCondicion: fila.IdCondicion, puedeVerCondicionRelacionada: fila.PuedeVerCondicionRelacionada }})
                }}
              />
              {fila?.PuedeEditar && !fila?.RequerimientoReservadoEnTrasladoYPromocion &&
                <FontAwesomeIcon
                  icon={faEdit}
                  size="lg"
                  className='hand-pointer'
                  title="Editar"
                  onClick={() => {
                    setModalEnabled({isEnable: true, component: EditarRequerimiento, data: {id: fila.IdRequerimientoPersonal }})
                  }}
                />
              }
              {fila?.PuedeVerFicha && 
                <Link to={`/fichadedatos/fromGestionFicha/${fila.IdEmpleadoNuevoIngreso}`}>
                  <FontAwesomeIcon
                    icon="user"
                    size="lg"
                    className='hand-pointer blue_innova_text'
                    title="Ver Ficha"
                  />
                </Link>
              }
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  )
}

export default TableWebBody;

const GenericTooltip = ({id, text}) => (
  <>
    <FontAwesomeIcon
      data-tip data-for={id}
      size='lg'
      icon='exclamation-triangle'
      style={{color: "#b3a11a"}}
    />
    <ReactTooltip id={id} place="top" effect="solid" className="tooltip-style">
      Renuncia Rechazada
    </ReactTooltip>
  </>
)